import React from 'react';
import { Loader2 } from 'lucide-react';

type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg';

interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
  label?: string;
}

const sizeClass: Record<SpinnerSize, string> = {
  xs: 'w-3.5 h-3.5',
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
};

/**
 * Standard 2026 spinner:
 * - use icon-based spinner (consistent stroke, no “fat border” variants)
 * - respects reduced-motion
 */
const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className = '', label }) => {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <Loader2 className={`${sizeClass[size]} animate-spin motion-reduce:animate-none text-primary-600`} />
      {label ? <span className="text-sm text-gray-500">{label}</span> : null}
    </div>
  );
};

export default Spinner;

